import BrandCard from "../BrandCard/BrandCard";
import { Brand } from "../../../../types";
import "./styles.css";
import { router } from "@inertiajs/react";
type BrandSectionProps = {
  title: string;
  icon: React.ReactNode;
  popular_brands: Brand[];
}

const BrandSection = (props: BrandSectionProps) => {
  const { title, popular_brands, icon } = props;
  

  const onBrandClick = (brand: Brand) => {
    router.get(`/vehicles`, {
      search: {
        q: brand.slug
      }
    })
  }

  return (
    <div className="max-w-screen-xl w-full mx-auto">
      <div className="brand-section-title">
        <i>{icon}</i>
        <span>{title}</span>
      </div>
      <div className="brand-section-cards">
        {popular_brands.map((brand: Brand) => (
          <BrandCard
            onClick={() => onBrandClick(brand)}
            key={brand.slug}
            popular_brand={brand} 
          />
        ))}
      </div>
    </div>
  )
}

export default BrandSection;